import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { CgpApiService } from '../cgp-api';
import { getEnv } from '../utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';

export interface Requestor {
   requesterId: number;
   rgmin: number;
   redsnetid: number;
   reason: string;
   rlastName: string;
   rfirstName: string;
   remail: string;
   rtelephone: string;
   rdateStamp: string;
   rlastUpdatedDate: string;
   rphotoUrl: string;
}

export interface TprEcmUser {
   active: boolean;
   constSource: string;
   email: string;
   firstName: string;
   gmin: string;
   id: number;
   initials: null;
   lastFirstName: string;
   lastName: string;
   mescId: string;
   phoneNo: string;
   restrictedToId: number;
   userRole: string;
   userRoleId: number;
   userSourceId: number;
   userSourceName: string;
}

@Injectable()
export class UserMaintenanceService {
   constructor(
      private readonly baseHttpService: BaseHttpService
   ) { }

   public getUsers(lastNameFilter, pageOptions?: PageOptions) {
      if (!pageOptions) {
         pageOptions = {
            page: 0,
            size: 10,
            sort: 'lastName',
            order: 'asc'
         };
      }
      const params = this.baseHttpService.generateHttpParams({
         page: pageOptions.page,
         size: pageOptions.size,
         sort: pageOptions.sort,
         order: pageOptions.order,
         lastNameFilter: lastNameFilter
      });
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/user`;
      return this.baseHttpService.get(url, { params });
   }

   public getRequestors(pageOptions?: PageOptions) {
      if (!pageOptions) {
         pageOptions = {
            page: 0,
            size: 10,
            sort: 'rFirstName',
            order: 'asc'
         };
      }

      const params = this.baseHttpService.generateHttpParams({
         page: pageOptions.page,
         size: pageOptions.size,
         sort: pageOptions.sort,
         order: pageOptions.order
      });

      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/requester`;
      return this.baseHttpService.get(url, { params });
   }

   public findUserByGmin(gmin) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/user/gmin/${gmin}`;
      return this.baseHttpService.get(url);
   }

   public updateUser(user) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/user`;
      return this.baseHttpService.put(url, user);
   }

   public saveUser(user) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/worker`;
      return this.baseHttpService.put(url, user);
   }

   public grantUserAccess(user: TprEcmUser) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/requester/grant-access`;
      const body = {
         active: true,
         gmin: user.gmin,
         id: 0,
         restrictedToId: user.restrictedToId,
         userRoleId: user.userRoleId,
         userSourceId: user.userSourceId
      };
      return this.baseHttpService.post(url, body);
   }

   public denyUserAccess(user) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/requester/deny-access`;
      return this.baseHttpService.delete(url, user);
   }

   public createUser(user) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/user`;
      return this.baseHttpService.post(url, user);
   }

   public deleteUser(id) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/worker/${id}`;
      return this.baseHttpService.delete(url);
   }

   public sendEmail(gmin) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/email/access/gmin/${gmin}`;
      return this.baseHttpService.get(url);
   }

   getRoles() {
      return this.get('maint/criteria/role');
   }

   getDesignSources() {
      return this.get('home/criteria/des-source');
   }

   getConstSources() {
      return this.get('maint/criteria/const-source-access');
   }

   private get(path) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}${path}`;
      return this.baseHttpService.get(url);
   }
}
